if (!window.productStickyPurchaseBarInitialized) {
  window.productStickyPurchaseBarInitialized = true;

  const getComposedText = (root) => {
    let text = root?.textContent || '';

    if (root?.shadowRoot) text += ` ${getComposedText(root.shadowRoot)}`;

    root?.querySelectorAll?.('*').forEach((element) => {
      if (element.shadowRoot) text += ` ${getComposedText(element.shadowRoot)}`;
    });

    return text;
  };

  const getKlarnaMonthlyLabel = () => {
    const placements = document.querySelectorAll('klarna-placement');

    for (const placement of placements) {
      const text = getComposedText(placement).replace(/\s+/g, ' ').trim();
      const match = text.match(/(?:from\s+)?(?:(?:[A-Z]{3})\s*)?(?:[$€£¥]\s*)?\d[\d.,]*(?:\s*(?:[A-Z]{3}))?\s*\/\s*(?:month|mo(?:nth)?)/i);

      if (match) {
        const amount = match[0]
          .replace(/\s*\/\s*/g, '/')
          .replace(/^from\s+/i, '');
        return `From ${amount}`;
      }
    }

    return '';
  };

  const syncKlarnaMonthlyLabels = (reset = false) => {
    const triggers = document.querySelectorAll('[data-sticky-klarna-trigger]');
    const monthlyLabel = getKlarnaMonthlyLabel();

    triggers.forEach((trigger) => {
      if (monthlyLabel) trigger.textContent = monthlyLabel;
      else if (reset) trigger.textContent = trigger.dataset.installmentFallback || 'Installments';
    });

    return Boolean(monthlyLabel);
  };

  const scheduleKlarnaLabelSync = () => {
    syncKlarnaMonthlyLabels(true);
    [250, 750, 1500, 3000, 5000, 8000].forEach((delay) => {
      window.setTimeout(syncKlarnaMonthlyLabels, delay);
    });
  };

  const syncStickyPurchaseBarHeight = (bar) => {
    const surface = bar.querySelector('.product-sticky-purchase-bar__surface');
    if (!surface) return;

    const height = Math.ceil(surface.getBoundingClientRect().height);
    if (height > 0) document.documentElement.style.setProperty('--sticky-purchase-bar-height', `${height}px`);

    if (bar.dataset.heightObserverBound !== 'true' && 'ResizeObserver' in window) {
      new ResizeObserver(() => syncStickyPurchaseBarHeight(bar)).observe(surface);
      bar.dataset.heightObserverBound = 'true';
    }
  };

  const mountStickyPurchaseBars = () => {
    const bars = document.querySelectorAll('product-sticky-form.product-sticky-purchase-bar');
    if (bars.length) document.documentElement.classList.add('has-sticky-purchase-bar');
    bars.forEach((bar) => {
      // Mount before wallet hydration so the first paint is viewport-fixed and
      // the PayPal element initializes in its final container.
      if (bar.parentElement !== document.body) document.body.append(bar);
      syncStickyPurchaseBarHeight(bar);

      if (window.Shopify?.designMode) return;

      if (bar.dataset.paymentVariantBound !== 'true') {
        const sourceForm = document.forms[bar.getAttribute('form')];
        const paymentVariantInput = bar.querySelector('[data-sticky-payment-variant]');

        if (sourceForm && paymentVariantInput) {
          sourceForm.addEventListener('variant:change', (event) => {
            if (!event.detail || !event.detail.variant) return;

            paymentVariantInput.value = event.detail.variant.id;
            paymentVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
            scheduleKlarnaLabelSync();
          });
          bar.dataset.paymentVariantBound = 'true';
        }
      }

      const acceleratedCheckout = bar.querySelector('shopify-accelerated-checkout');
      const paypalButton = acceleratedCheckout?.querySelector('shopify-paypal-button');
      const paymentInitialized = !acceleratedCheckout
        || acceleratedCheckout.hasAttribute('disabled')
        || (paypalButton && (paypalButton.hasAttribute('disabled')
          || Boolean(paypalButton.querySelector('iframe[title^="PayPal"]'))));

      if (!paymentInitialized) {
        if (bar.dataset.mountPending !== 'true') {
          bar.dataset.mountPending = 'true';
          window.setTimeout(() => {
            bar.dataset.mountPending = 'false';
            mountStickyPurchaseBars();
          }, 100);
        }
        return;
      }

    });
  };

  const observeStickyPurchaseBars = () => {
    if (!document.body) return;
    new MutationObserver(mountStickyPurchaseBars).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      mountStickyPurchaseBars();
      observeStickyPurchaseBars();
      scheduleKlarnaLabelSync();
    }, { once: true });
  }
  else {
    mountStickyPurchaseBars();
    observeStickyPurchaseBars();
    scheduleKlarnaLabelSync();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sticky-klarna-trigger]');
    if (!trigger) return;

    const placement = document.querySelector('klarna-placement');
    placement?.shadowRoot?.querySelector('button[part="osm-cta"]')?.click();
  });
}
